import React from "react";
import { Stack, Image, Text } from "@bookingcom/bui-react";
export function FlightDetailsSectionTitleMobileUI(props) {
    const { asset, title, attributes, mixin } = props;
    return (React.createElement(Stack, { direction: "row", mixin: mixin, attributes: attributes },
        asset ? (React.createElement(Image, { alt: "", attributes: { "aria-hidden": true }, height: 10, width: 10, asset: asset, contentMode: "fit" })) : undefined,
        React.createElement(Stack.Item, { grow: true, mixin: { paddingBlockStart: 1.6 } },
            React.createElement(Text, { tagName: "h2", variant: "headline_3" }, title))));
}
